import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { MarketProductItem } from '~/api/model';

// DTO 타입은 직접 정의한다. (OAISchema/shoebill.ts import 금지 — api-typegen §0)
// 공유 하위 형상(상품 아이템)은 이미 정의된 Zod Model 타입을 재사용한다.

/** 커서 페이지네이션된 쇼케이스 상품 목록 DTO */
type CursorPagedShowcaseProducts = {
  content: MarketProductItem[];
  hasNextPage: boolean;
  lastId?: number;
  searchAfter?: string[];
  sortType?: string;
};

/** 쇼케이스 요약 DTO (그룹 내 탭 항목, ShowcaseResponse) */
type ShowcaseSummaryDto = {
  code: string;
  id: number;
  name?: string;
  mainImageUrl?: string;
};

/** 쇼케이스 그룹 응답 DTO (ShowcaseGroupResponse) */
export type ShowcaseGroupResponse = {
  code?: string;
  name?: string;
  description?: string;
  mainImageUrl?: string;
  thumbnailImageUrl?: string;
  showcases: ShowcaseSummaryDto[];
};

/** 쇼케이스 상품 응답 DTO (MarketShowcaseProductsResponseV3) */
export type ShowcaseProductsResponse = {
  code?: string;
  count?: number;
  name?: string;
  description?: string;
  mainImageUrl?: string;
  thumbnailImageUrl?: string;
  products?: CursorPagedShowcaseProducts;
};

export type ShowcaseProductsParams = {
  code?: string;
  deliveryType?: string;
  productType?: string;
  isForHomeProduct?: string;
  salesTarget?: string;
  sortType?: string;
  size?: number;
  searchAfter?: string[];
  [key: string]: unknown;
};

export interface ShowcaseDataSource {
  // Query
  getShowcaseGroup(showcaseGroupCode: string): Promise<ShowcaseGroupResponse>;
  getShowcaseProducts(
    params: ShowcaseProductsParams,
  ): Promise<ShowcaseProductsResponse>;
}

export class ShowcaseDataSourceImpl implements ShowcaseDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getShowcaseGroup(showcaseGroupCode: string) {
    return this.client.request<ShowcaseGroupResponse>({
      url: `/api/market-place/v1/showcase-groups/${showcaseGroupCode}`,
      method: 'get',
    });
  }

  async getShowcaseProducts(params: ShowcaseProductsParams) {
    return this.client.request<ShowcaseProductsResponse>({
      url: '/api/market-place/v4/showcases',
      method: 'get',
      params: { ...params },
    });
  }
}

export const showcaseDataSource = new ShowcaseDataSourceImpl();
